import { useCallback, useMemo } from 'react';
import { OptionKey } from '@common-fe/common-fe';

import { useEmployerReactivationStore } from '@/modules/employer/components/EmployerReactivation/stores/useEmployerReactivation.store';
import { ReactivationPlanToSubmit } from '@/modules/employer/components/EmployerReactivation/types';

export const useEmployerReactivationPlanField = (planId: string, isPlanLevelFunding?: boolean) => {
  const selectedPlans = useEmployerReactivationStore((state) => state.selectedPlans);
  const setSelectedPlans = useEmployerReactivationStore((state) => state.setSelectedPlans);

  const selectedPlan = useMemo(
    () => selectedPlans.find((p: ReactivationPlanToSubmit) => p.plan_id === Number(planId)),
    [selectedPlans, planId]
  );

  const checked = useMemo(() => !!selectedPlan, [selectedPlan]);

  const bankAccountValue = useMemo(
    () => (selectedPlan?.external_bank_account_id ? String(selectedPlan.external_bank_account_id) : undefined),
    [selectedPlan]
  );

  const handleCheckboxChange = useCallback(() => {
    if (checked) {
      setSelectedPlans(selectedPlans.filter((p: ReactivationPlanToSubmit) => p.plan_id !== Number(planId)));
    } else {
      setSelectedPlans([...selectedPlans, { plan_id: Number(planId), external_bank_account_id: 0, isPlanLevelFunding }]);
    }
  }, [checked, selectedPlans, planId, setSelectedPlans]);

  const handleBankAccountChange = useCallback(
    (value: OptionKey) => {
      setSelectedPlans(
        selectedPlans.map((p: ReactivationPlanToSubmit) =>
          p.plan_id === Number(planId) ? { ...p, external_bank_account_id: Number(value) } : p
        )
      );
    },
    [selectedPlans, planId, setSelectedPlans]
  );

  return {
    checked,
    bankAccountValue,
    handleCheckboxChange,
    handleBankAccountChange,
  };
};
